import { createContext, useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { isTokenValid } from '../utils/checkTokenValidity';
import logger from '../utils/logger';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const navigate = useNavigate();
  const currentLocation = useLocation();
  // Expose for debugging:
  if (typeof window !== 'undefined') {
    window.__auth = { isLoggedIn, userRole };
  }

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('user'));
    if (userData && userData.token) {
      if (isTokenValid(userData.token)) {
        logger.log('✅ Token valid, user remains logged in');
        setIsLoggedIn(true);
        setUserRole(userData.role);
        
        if (currentLocation.pathname === '/' || currentLocation.pathname === '/login') {
          if (userData.role === 'professor') {
            navigate('/professor-dashboard');
          } else if (userData.role === 'student') {
            navigate('/student-dashboard');
          } else if (userData.role === 'admin') {
            navigate('/admin'); 
          }
        }
      } else {
        logger.log('❌ Token expired, clearing session');
        localStorage.removeItem('user');
        setIsLoggedIn(false);
        setUserRole(null);
        navigate('/login');
      }
    } else {
      setIsLoggedIn(false);
      setUserRole(null);
    }
  }, [navigate, currentLocation]);

  return (
    <AuthContext.Provider value={{ isLoggedIn, userRole, setIsLoggedIn, setUserRole }}>
      {children}
    </AuthContext.Provider>
  );
};